module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Commode#2-b309ead063aeba3d5622fdaedc72ce24.svg";